<template>
  <v-dialog v-if="visible" v-model="visible" width="850" persistent>
    <v-card rounded="xxl">
      <v-container>
        <v-row align="center">
          <v-col sm="2" align="center">
            <v-icon
              large
              style="color: red; font-size: 90px; width: 200px !important"
            >
              mdi-alert-outline
            </v-icon>
          </v-col>
          <v-col sm="10" align="center">
            <v-card-text>
              <v-row>
                <v-col>
                  <h1 style="color: red">Oops !</h1>
                  <br />
                  <h3>
                    Something went wrong. Please check whether you are
                    authorized to perform this action.
                    <br />
                    If you are <span class="red--text">not</span>, kindly
                    contact your <span class="green--text">administrator</span>.
                    <br />
                    If you are <span style="color: #1b5e20">authorized</span>,
                    try restarting the application or logging in again.
                  </h3>
                  <br />
                  <v-btn color="error" @click="close"> Close </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
  created() {
    this.$root.$on("unauthorised", this.show);
  },
  methods: {
    show() {
      this.visible = true;
      setTimeout(() => {
        window.location.href = "/auth/login";
      }, 13000);
    },
    close() {
      this.visible = false;
      window.location.href = "/auth/login";
    },
  },
};
</script>

<style scoped>
/* Customize styles as needed */
</style>
